import { useState } from 'react';

export const useExpanded = () => {
  const [expanded, setExpanded] = useState(false);

  return { expanded, setExpanded };
};
